import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';
import { versionCompare } from '../../utils/versioning';

export const useCheckVersion = () => {
	const { getStreamData } = useGetStreamData();

	const checkVersion = useCallback(
		(stream, version) => {
			const newVersion = { ...version };
			const app_version = getStreamData(stream, '/version');
			if (app_version) {
				newVersion.current_version = app_version;
				const check_acceptable = versionCompare(
					app_version,
					newVersion.minimum_version,
				);
				const check_latest = versionCompare(
					app_version,
					newVersion.latest_version,
				);

				if (check_acceptable >= 0) {
					newVersion.accepted = true;
				}
				if (check_latest >= 0) {
					newVersion.latest = true;
				}
				newVersion.checked = true;
			}
			return newVersion;
		},
		[getStreamData],
	);

	return { checkVersion };
};
